import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";
import { useCloudStatus } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-cloud-status";
import { useCloudStatusRedirection } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-cloud-status-redirection";
import { useConfirmationPageType } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-confirmation-page-type";

import ErrorView from "./error/error-view";
import RobotsView from "./robots/robots-view";
import TimeoutView from "./timeout/timeout-view";
import TipsView from "./tips/tips-view";

const ContainerStyle = css({
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    alignSelf: "center"
});
const InnerStyle = css({
    alignItems: "stretch",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    padding: "3rem",
    fontWeight: "normal",
    fontFamily: wacToken("font.charlie.text"),
    marginBlockStart: "30px"
});

export const LegacyConfirmationPageLayout = ({
    children
}: PropsWithChildren) => {
    return (
        <div css={ContainerStyle}>
            <div css={InnerStyle}>{children}</div>
        </div>
    );
};

/* istanbul ignore next */
const ViewSwitch = () => {
    let confirmationPageView = <RobotsView />;
    const { createCloudStatus, startPerceivedProvisioningTimer } =
        useCloudStatus();
    const { deferRedirectView } = useCloudStatusRedirection();
    const confirmationPageType = useConfirmationPageType(
        createCloudStatus,
        deferRedirectView
    );

    switch (confirmationPageType) {
        case "tips":
            confirmationPageView = <TipsView />;
            break;
        case "timeout":
            confirmationPageView = <TimeoutView />;
            break;
        case "error":
            confirmationPageView = <ErrorView />;
            break;
        case "redirect":
            // Before redirecting to product, do not show a blink of default robots view
            return;
        default:
            startPerceivedProvisioningTimer();
            confirmationPageView = <RobotsView />;
    }

    // TODO: Confirm if each child component needs this confirmation page layout.
    return (
        <LegacyConfirmationPageLayout>
            {confirmationPageView}
        </LegacyConfirmationPageLayout>
    );
};

export default ViewSwitch;
